import LocationUploadFile from "./location-upload-file";

export default LocationUploadFile;